import axios from 'config/api';
import { toast } from 'react-toastify';

export async function subscribeNewsletter() {
  return axios
    .post(`/user/newsletter/`, {})
    .then(response => {
      const { data, status } = response;
      console.warn('subscribeNewsletter', data);

      if (status === 200) {
        toast.success('Email cadastrado com sucesso na newsletter');
        console.warn('status', status);
        return {
          type: 'NEWSLETTER_SUCCESS',
        };
      }

      throw response;
    })
    .catch(err => {
      toast.error('Email já cadastrado na newsletter');
      return {
        type: 'NEWSLETTER_FAILURE',
      };
    });
}
